import axios from "axios";
import { Decode, Encode } from "../../Models/Request/Redirection/Redirection";

export function decode(body: Decode) {
  return axios.post("/public/decode", body);
}

export function encode(body: Encode) {
  return axios.post("/public/encode", body);
}
